define('../app/fukit/behavior/update.css.values.on.page.resize.behavior',['require','exports','module','underscore','jquery','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      $  = require('jquery'),
      Mn = require('marionette');

  var UpdateCssValuesOnPageResizeBehavior = Mn.Behavior.extend({
    defaults: {
      cssValues: null,
      targetElementIsParent: false,
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      var self = this;
      $(window).on('resize', this.boundUpdateAttributes());
    },

    onRender: function() {
      var self = this;
      _.defer(function() {
        self.updateAttributes();
      });
    },

    boundUpdateAttributes: function() {
      if (!this._cachedBoundUpdateAttributes) {
        this._cachedBoundUpdateAttributes = _.bind(this.updateAttributes, this);
      }

      return this._cachedBoundUpdateAttributes;
    },

    updateAttributes: function() {
      var cssValues = this.getOption('cssValues') || {};

      _.each(
        cssValues,
        function(cssValue, value) {
          cssValue || (cssValue = {});
          //prettier-ignore
          var selector  = cssValue.selector,
              formatter = cssValue.formatter;

          if (_.isArray(selector)) {
            var $selectorEls = selector.map(function(el) {
              return $(el);
            }, []);

            this.formatAndSetValueFromSelectorEl(value, this.getTargetElement(), $selectorEls, formatter);
          } else {
            this.formatAndSetValueFromSelectorEl(value, this.getTargetElement(), [$(selector)], formatter);
          }
        },
        this
      );
    },

    formatAndSetValueFromSelectorEl: function(value, $el, args, formatter) {
      if (_.isFunction(formatter)) {
        $el.css(value, formatter.apply(this, args));
      }
    },

    getTargetElement: function() {
      if (this.getOption('targetElementIsParent')) {
        return this.view.$el.parent();
      }
      return this.view.$el;
    },

    onDestroy: function() {
      $(window).off('resize', this.boundUpdateAttributes());
    },
  });

  module.exports = UpdateCssValuesOnPageResizeBehavior;
});

